import {bindTrainingSession, releaseTrainingSession} from '@/services/trainingService.js';
import {TRAINING_ENABLED} from '@/config/features.js';

/**
 * The training route acts as a clone of one of the player's characters, and
 * only for as long as it is on screen. Binding in the guard rather than in the
 * view means every request the route makes carries the acting character — the
 * ones fired before the view mounts included — and that leaving un-binds it
 * even when the view never mounted at all.
 *
 * No open session is not an error to report, it is a route that does not exist
 * yet: the player goes back to the lobby, where a training is started.
 */
export function createTrainingGuard(lobbyRoute, bind = bindTrainingSession, release = releaseTrainingSession, enabled = TRAINING_ENABLED) {
    return async (to) => {
        if (!to.meta?.training) {
            release();
            return true;
        }
        if (!enabled) {
            release();
            return {...lobbyRoute, replace: true};
        }
        const raw = to.query?.character;
        const requested = Array.isArray(raw) ? raw[0] : raw;
        const session = await bind(requested || undefined);
        return session ? true : {...lobbyRoute, replace: true};
    };
}
